import Budgets from "@components/modules/budgets/listing";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { FullScreenContainer } from "@src/components/ui-kit";
import { NavigationBudget } from "@src/components/widgets/AppSubNav/navigation-budget";
import { useUnsavedWorkMessage } from "@src/components/widgets/BudgetovacIframe/hooks";
import { getQueryParamOptional } from "@src/utils/routing";
import { FormMode } from "@src/utils/types";
import { createFileRoute } from "@tanstack/react-router";
import { uniqueId } from "lodash";
import { useRouter } from "next/router";
import { useState } from "react";

const Page = () => {
  const { query } = useRouter();
  const budgetId = getQueryParamOptional("budget_id", query);
  const projectId = getQueryParamOptional("project_id", query);

  const [iframeKey, setIFrameKey] = useState(uniqueId());

  const { message, reset } = useUnsavedWorkMessage();

  const onSelectPage = () => {
    if (!message || (message && window.confirm(message))) {
      reset();

      /**
       * Reload iframe on select the same page
       */
      setIFrameKey(uniqueId());
      return true;
    }

    return false;
  };

  return (
    <MainLayout
      fullWidth
      noBottomMargin
      noGutters
      title={t`Budgets`}
      navigation={
        <NavigationBudget mode={FormMode.EDIT} onSelect={onSelectPage} />
      }
    >
      <FullScreenContainer noBottomMargin>
        <Budgets
          iframeKey={iframeKey}
          page={"budgets"}
          embedded
          proposals={true}
          showMenu={false}
          budgetId={budgetId}
          projectId={projectId}
        />
      </FullScreenContainer>
    </MainLayout>
  );
};

export const Route = createFileRoute("/budgets/proposals/")({
  component: Page,
});
